var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-toggle":"modal","data-target":"#exampleModal"},on:{"click":function($event){return _vm.click(_vm.data)}}},[_vm._v(" View Row "+_vm._s(_vm.data.id)+" Modal ")])}
var staticRenderFns = []

export { render, staticRenderFns }